<div class="padding-standard">
  <p class="text-body" *ngIf="!!alternative && !forRecipe">
    {{ 'i18n.menuProfitPro.unitOfMeasure.alternativeInstruction' | translate }}
  </p>
  <p class="text-body" *ngIf="!!alternative && !!forRecipe">
    {{ 'i18n.menuProfitPro.unitOfMeasure.alternativeInstruction2' | translate }}
  </p>
  <p class="text-body" *ngIf="!alternative">
    {{ 'i18n.menuProfitPro.unitOfMeasure.tldr1' | translate }}
  </p>
  <p class="text-body" *ngIf="!alternative">
    {{ 'i18n.menuProfitPro.unitOfMeasure.tldr2' | translate }}
  </p>
</div>
